import { BasketState } from '@websrc/Typings/DanteBasket'
import { createContext } from 'react'

import { BasketApiMethod } from './BasketTypes'

export const BasketStateContext = createContext<BasketState | undefined>(undefined)

export const BasketAPIContext = createContext<BasketApiMethod | null>(null)
